export const UspData = [
    {
        name:"24 x 7 Free Support",
        description:"Passage Of Lorem Ipsum, You Need To Be Amet Embarrassing",
        icon:"FaUserPlus"
    },
    {
        name:"Free Shipping",
        description:"Passage Of Lorem Ipsum, You Need To Be Amet Embarrassing",
        icon:"FaTruck"
    },
    {
        name:"Money Back Gaurantee",
        description:"Passage Of Lorem Ipsum, You Need To Be Amet Embarrassing",
        icon:"FaRupeeSign"
    },
    {
        name:"Win Free Vouchers",
        description:"Passage Of Lorem Ipsum, You Need To Be Amet Embarrassing",
        icon:"FaMoneyCheck"
    },
    {
        name:"Free Shipping",
        description:"Passage Of Lorem Ipsum, You Need To Be Amet Embarrassing",
        icon:"FaTruck"
    },
]